module.exports = __webpack_public_path__ + "img/003_back.dc683982.png";